import { Injectable } from '@angular/core';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import {Observable} from 'rxjs';
import {Dictionary} from '@common_libraries/helpers/Dictionary';

@Injectable({providedIn: 'root'})
export class BuildVersionService {

  public constructor(private servLib: ServiceLibrary) {
  }

  GenerateBuildVersion() {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/BuildVersion/GenerateBuildVersion', ServiceLibrary.ContentType.JSON, parameters, null, false);
  }

  GetLatestBuildVersion(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/BuildVersion/GetLatestBuildVersion', ServiceLibrary.ContentType.JSON, parameters, null, false);
  }

}
